export const SUBJECTS_TITLE = 'Subjects'
export const ALL_SUBJECTS_ID = 'all'
export const SOCIAL_STUDIES_ID = 'Social Studies'
export const MATHEMATICS_ID = 'Mathematics'
export const ENGLISH_LANGUAGE_ARTS_ID = 'English Language Arts'
export const SCIENCE_ID = 'Science'
export const ART_AND_DESIGN_ID = 'Art and Design'
export const ENGLISH_AS_A_SECOND_LANGUAGE_ID = 'English as a Second Language'
export const FOREIGN_LANGUAGES_ID = 'Foreign Languages'
export const GEOGRAPHY_ID = 'Geography'
export const HEALTH_AND_PHYSICAL_EDUCATION_ID = 'Health and Physical Education'
export const HISTORY_ID = 'History'
export const RELIGION_ID = 'Religion'
export const CITIZENSHIP_ID = 'Citizenship'
export const ICT_ID = 'ICT'
export const MUSIC_ID = 'Music'
export const SPECIAL_EDUCATION_ID = 'Special Education'
export const MODERN_FOREIGN_LANGUAGES_ID = 'Modern Foreign Languages'
export const CROSS_CURRICULAR_ID = 'Cross-curricular'
export const OTHER_ID = 'Other'
export const ARTS_EDUCATION_ID = 'Arts Education'
export const CAREER_TECHNICAL_EDUCATION_ID = 'Career Technical Education'
export const HEALTH_AND_PE_ID = 'Health and PE'
export const LANGUAGE_ARTS_ID = 'Language Arts'
export const TECHNOLOGY_EDUCATION_ID = 'Technology Education'
export const WORLD_LANGUAGES_ID = 'World Languages'
export const LIBRARY_MEDIA_ID = 'Library Media'
